import React from 'react';
import Root from '../Root';

const CmsPage = ({ children, pageContext }) => {
  return <Root pageContext={pageContext}>{children}</Root>;
};

export default CmsPage;
